import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import List from '../../components/List';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import LoadingIndicator from '../../components/LoadingIndicator';
import FyrkListItem from '../../containers/FyrkListItem';
import FyrkListItemCard from '../../containers/FyrkListItemCard';
import Masonry from 'react-masonry-component';

const masonryOptions = {
  transitionDuration: 0,
};

const imagesLoadedOptions = { background: '.my-bg-image-el' };

const styles = theme => ({
  root: {
    flexGrow: 1,
    justifyContent: 'left',
  },
  control: {
    padding: theme.spacing(2),
  },
  flexNoneTitle: {
    textAlign: "left",
    paddingLeft: "1em",
    paddingRight: "6em",
    width: "100%",
    flex: "1",
  },
  flexNone: {
    flex: "1",
  },
  rowitem: {
    [theme.breakpoints.down("xs")]: {
      display: `none`,
    },

    [theme.breakpoints.up("md")]: {},
    [theme.breakpoints.up("lg")]: {},
    marginBottom: "6px",
  },
  griditem: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      height: '543px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },

    [theme.breakpoints.up('md')]: {
      width: '33%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '25%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
    [theme.breakpoints.up('xxl')]: {
      width: '16.5%',
    },
  },
  griditemhome: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '33%',
    },
  },
});
function FyrkList(props) {
  const {
    loading,
    error,
    fyrk,
    userid,
    user,
    masonryview,
    listview,
    favoriter,
  } = props;

  
  const { classes } = props;
  let homepage = false;
  let listclass = classes.griditem;

  if (props.home) {
    homepage = true;
    listclass = classes.griditemhome;
  }
  let limit = 0;
  let limitset = false;
  if(props.limit) {
    limit = props.limit;
    limitset =true;
  }
  if (error !== false && masonryview) {
    const ErrorComponent = () => (
      <ListItem item="Something went wrong, please try again!" />
    );
    return <List component={ErrorComponent} />;
  }

  if (fyrk.length > 0  && fyrk !== false && masonryview) {
    return (
      <Masonry
        className="my-gallery-class" // default ''
        options={masonryOptions} // default {}
        columns={4} // default 2
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        imagesLoadedOptions={imagesLoadedOptions} // default {}
      >
        {fyrk.map((card, i) => {
          if(limitset && i >= limit) {
          } else {
            return(
              <Grid className={listclass} key={i} item={card} >
                <FyrkListItemCard
                  user={user}
                  userid={userid}
                  item={card}
                  key={i}
                  favoriter={favoriter}
                />
              </Grid>
            );
          }
          }
        )

        }
      </Masonry>
    );
  }
  if (fyrk.length > 0  && fyrk !== false && listview) {
    return (
      <Grid
        container
        justifyContent="flex-start"
        className={classes.root}
        spacing={6}
      >
      <Grid item md={1} />
      <Grid item xs={12} md={10}>
      <ListItem 
        className={classes.rowitem}>
        <ListItemText primary="BIDRAGSKÄLLA" className={classes.flexNoneTitle} />
        <ListItemText primary="RUBRIK" className={classes.flexNone} />
        <ListItemText primary="DATUM" className={classes.flexNone} /> 
        <ListItemText primary="KATEGORIER" className={classes.flexNone} />  
        <ListItemText primary="" className={classes.flexNone} />
        </ListItem>
        {fyrk.map((card, i) => (
          <FyrkListItem user={user} userid={userid} item={card} key={i} favoriter={favoriter} />
        ))}
        </Grid>
      </Grid>
    );
  }
  return null;
}

FyrkList.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.any,
  fyrk: PropTypes.any,
};

export default withStyles(styles)(FyrkList);
